<template>
  <div
    class="transaction-table-item__col transaction-table-item__actions"
    v-click-outside="hideActionsMenu"
    @click.stop
  >
    <div
      class="transaction-table-item__actions-btn"
      @click.stop="toggleActionsMenu"
    >
      <svg
        width="20"
        height="4"
        viewBox="0 0 20 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="2" cy="2" r="2" fill="#B9C4D8" />
        <circle cx="18" cy="2" r="2" fill="#B9C4D8" />
        <circle cx="10" cy="2" r="2" fill="#B9C4D8" />
      </svg>
    </div>
    <div class="transaction-table-item__actions-menu" v-if="isShowActionsMenu">
      <template v-if="actions.length > 0">
        <div
          class="transaction-table-item__actions-menu-item"
          v-for="action in actions"
          :class="{ disabled: actionsPending.includes(action.id) }"
          @click.stop="makeAction(action)"
        >
          {{ action.title }}
        </div>
      </template>
      <template v-else>
        <div class="transaction-table-item__actions-no-actions">
          {{ $t('transaction-actions.no-available-actions') }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
export default {
  name: 'TransactionsTableActionsButton',
  props: {
    actions: {
      type: Array,
    },
  },
  data() {
    return {
      isShowActionsMenu: false,
      actionsPending: [],
    }
  },
  methods: {
    toggleActionsMenu() {
      this.isShowActionsMenu = !this.isShowActionsMenu
    },
    hideActionsMenu() {
      this.isShowActionsMenu = false
    },
    makeAction(action) {
      if (this.actionsPending.includes(action.id)) {
        return
      }

      this.actionsPending.push(action.id)
      this.isShowActionsMenu = false

      $emit(this, 'actionFired', action)
    },
    actionFinished(actionName) {
      this.actionsPending.splice(
        this.actionsPending.findIndex((_a) => _a === actionName),
        1
      )
    },
  },
  emits: ['actionFired'],
}
</script>

<style lang="scss" scoped>
.transaction-table-item {
  &__actions {
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    //width: 10%;
    position: relative;
    padding-left: 20px;
    padding-right: 20px;
    opacity: 1;

    &-btn {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;

      &:hover {
        opacity: 0.8;
      }
    }

    &-no-actions {
      white-space: nowrap;
      cursor: not-allowed;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #64748B;
      filter: grayscale(100%);
    }

    &-menu {
      position: absolute;
      bottom: 18px;
      background: #ffffff;
      box-shadow: 0 8px 20px rgb(225 235 253 / 38%);
      border-radius: 12px;
      padding: 20px 20px 24px 32px;

      &-item {
        white-space: nowrap;
        margin-bottom: 15px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #64748B;
        cursor: pointer;

        &.disabled {
          filter: grayscale(100%);
        }

        &:hover {
          opacity: 0.8;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
